import React from 'react';
import PropTypes from 'prop-types';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuList from '@material-ui/core/MenuList';
import Button from '@material-ui/core/Button';
import { Routing, Pin } from '../icons/index';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

const MENU_SIZE = 350;

const styles = theme => ({
  text: {},
  icon: {},
  contextMenu: {
    padding: '5px',
    fontSize: '1em',
    backgroundColor: '#fff', 
    position: 'absolute',
    justifyContent: 'space-between'
  },
  button: {
    backgroundColor: '#a20808',
    color: '#fff',
    width:'100%',
    fontSize: '1rem',
    '&:hover': {
      color: theme.palette.action.hoverText
    },
    padding: '0 6px'
  },
  buttonsWrap:{
    padding: '4px 0',
    width: '80%'
  }
});

const renderItems = function({ items, clickHandler, position, classes })  {

  var key = 0;

  return items.map((item) => {

    return (<Button key={key++} className={classes.button} onClick={(ev)=>{ clickHandler(ev, position); }}>
        <div style={{float:'left'}}><Routing style={{width: '32px', width: 'auto'}} viewBox="10 0 32 32"/></div>{item.name}
      </Button>);
  });
};

const ContextMenu = ({ items, clickHandler, position, classes, title, coords, autoHeight, isRoutingAllowed }) => {
  
  coords = false;

  if((window.innerWidth - position[0]) < MENU_SIZE) {

    var x = position[0] - MENU_SIZE;
    var reverse = true;
  } else {
    var reverse = false;
    var x = (position !== null ? position[0] : 0);
  }

  return (<Paper className={classes.contextMenu} style={{
        left: x,
        borderRadius: 0,
        top: (position !== null ? position[1] : 0),
        display: (position.length > 0 ? 'flex': 'none'),
        maxWidth: MENU_SIZE + 'px',
        flexDirection: (reverse ? 'row-reverse' : 'row'),
    }}>
    <div><Pin viewBox="6 0 32 32" style={{width: '40px',
    height: 'auto'}}/></div>
    <div><div>{title ? <Typography component="p" style={{color:'#515151', fontSize: '0.9em', margin: '15px 10px 0 0'}}>{title}</Typography> : "" }</div>
    <div>{coords ? <Typography component="p" style={{color:'#515151', fontSize: '0.9em'}}>{coords}</Typography> : "" }</div>
    <div className={classes.buttonsWrap}>{title && !isRoutingAllowed ? renderItems({items, clickHandler, position, classes}) : ""}</div></div>
  </Paper>);
};

ContextMenu.propTypes = {
  autoHeight: PropTypes.bool,
  items: PropTypes.array.isRequired, //{name: '', id: '', disabled: bool}
  clickHandler: PropTypes.func.isRequired,
  position: PropTypes.array,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  isRoutingAllowed: PropTypes.bool
};

export default withStyles(styles)(ContextMenu);


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/contextmenu/index.js